export default {
  SUCCESS: {
    label: 'Sucesso',
    icon: 'check',
    class: 'has-text-primary',
  },
  PREPARING: {
    label: 'Em preparação',
    icon: 'sync-alt',
    class: 'has-text-grey',
  },
  PROCESSING: {
    label: 'Processando',
    icon: 'sync-alt',
    class: 'has-text-grey',
  },
  TO_BE_PROCESSED: {
    label: 'Pronto para Processar',
    icon: 'sync-alt',
    class: 'has-text-grey',
  },
  PROCESSING_ERROR: {
    label: 'Erro no Processamento',
    icon: 'exclamation-triangle',
    class: 'has-text-danger',
  },
  UNEXPECTED_ERROR: {
    label: 'Erro Inesperado',
    icon: 'exclamation-triangle',
    class: 'has-text-danger',
    help: 'Falha ao importar planilha de resultados.\n' +
      '- Verifique se existe alguma fórmula ou macro ativo na planilha de importação\n' +
      '- Faça o download do modelo, e tente novamente',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/enums/importFileStatus.enum.js